import { Grid } from "@mui/material";
import { useEffect } from "react";
import {
    Control,
    FieldErrors,
    UseFormRegister,
    UseFormReset
} from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";

interface StatusProps {
    control: Control<any>;
    errors: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    statusId?: string;
    config:any;
}

export const UpdateStatus: React.FC<StatusProps> = ({
    control, errors, register, id, reset, statusId,config
}) => {


    useEffect(() => {
        reset();
    }, [id, reset]);
    return (
        <Grid >
            <Grid className="modal-input" container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <WSSelectField
                        options={config}
                        rules={{ required: true }}
                        {...register("newStatus")}
                        id="newStatus"
                        control={control}
                        label="Status"
                        name="newStatus"
                    />
                </Grid>
               
            </Grid>
        </Grid>
    );
};
